var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"error"}},[_c('div',{staticClass:"stickerWrapper"},[_c('sticker',{attrs:{"src":"error.png","width":256}})],1),_c('div',[_c('span',[_vm._v(_vm._s(_vm.$t(_vm.label)))])])])}
var staticRenderFns = []

export { render, staticRenderFns }